"use client";

import dynamic from "next/dynamic";
import { usePlayerStore } from "@gerama/stores";

/**
 * Client-only widgets that don't affect the first paint — loaded after
 * hydration so they stay out of the initial JS (the player alone pulls in
 * hls.js, the biggest dependency on every page). `ssr: false` is only allowed
 * from a Client Component, hence this wrapper.
 */
const PlayerBar = dynamic(() => import("@/components/player-bar").then((m) => m.PlayerBar), {
  ssr: false,
});
const SessionRefresher = dynamic(
  () => import("@/components/session-refresher").then((m) => m.SessionRefresher),
  { ssr: false },
);
const DevToolsGuard = dynamic(
  () => import("@/components/devtools-guard").then((m) => m.DevToolsGuard),
  { ssr: false },
);
const OpenInAppBanner = dynamic(
  () => import("@/components/open-in-app-banner").then((m) => m.OpenInAppBanner),
  { ssr: false },
);
const PlaylistPickerDialog = dynamic(
  () => import("@/features/playlists/playlist-picker").then((m) => m.PlaylistPickerDialog),
  { ssr: false },
);

/** The player (and hls.js with it) is only fetched once something is queued — most visits never play anything. */
export function DeferredPlayer() {
  const hasTrack = usePlayerStore((s) => s.queue.length > 0);
  return hasTrack ? <PlayerBar /> : null;
}

export function DeferredWidgets() {
  return (
    <>
      <SessionRefresher />
      <DevToolsGuard />
      <OpenInAppBanner />
      <PlaylistPickerDialog />
    </>
  );
}
